import { KEYBOARD_KEYS } from "./constants"

export const elementWasSelected = e => {
	return e.key === "Enter" || e.key === " "
}

/**
 * Actions to be done only if an element was selected through keyboard
 */
export const handleKeyboardSelect = (e, onSelect, preventDefaultAction = true) => {
	if (!elementWasSelected(e)) return

	if (preventDefaultAction) {
		e.preventDefault()
	}

	onSelect?.()
}

/**
 * Each symbol/keyboard key is being matched to a unique action as specified in the KEYBOARD_KEYS object.
 * This function gets as params the fired event and the keymap. The event key is being passed inside the
 * KEYBOARD_KEYS and gets the name of the unique action back. The given keyMap pair has as keys the unique actions (the keys of KEYBOARD_KEY_SET)
 * and as values the actions that need to be done if the key is a match.
 * So, on Enter press, we should pass [KEYBOARD_KEY_SET.Select]: () => {}, where e.key = "Enter", "Enter" key inside KEYBOARD_KEYS returns value "Select" and goes on.
 */
export const handleKeyPress = (e, keyMap) => {
	const { key, shiftKey } = e

	if (key === KEYBOARD_KEYS.Tab && shiftKey) {
		keyMap[KEYBOARD_KEYS.ShiftAndTab]?.(e)
		return
	}

	// Get the key action name (if "+" symbol was pressed, get back "Plus")
	const mappedKey = KEYBOARD_KEYS[key]
	// Parse value by action name
	keyMap[mappedKey]?.(e)
}
